import React from 'react';
import { DialogDelete } from 'shared/ui/Dialog';
import { useDeleteMechanicMutation } from 'features/deleteMechanic/api/deleteMechanicApi';

type DeleteDialogMechanicPropsType = {
  promoId: string;
  deleteId: number;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const DeleteDialogMechanic = ({ promoId, deleteId, open, setOpen }: DeleteDialogMechanicPropsType) => {
  const [deleteMechanicRequest] = useDeleteMechanicMutation();
  const onSubmit = () => {
    deleteMechanicRequest({
      id: promoId,
      body: {
        objective_id: deleteId,
      },
    });
  };

  return (
    <DialogDelete
      title="Вы действительно хотите удалить механику?"
      open={open}
      setOpen={setOpen}
      onConfirm={onSubmit}
    />
  );
};
